import Joi from '@hapi/joi'

export const BagQRPrintFilteringSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group required`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Operation Entity required`,
        "any.required": `Operation Entity required`
    }),
    collectionPointID: Joi.number().allow(0).optional().label("Division")
}

export const BagQRPrintAddingSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group required`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Operation Entity required`,
        "any.required": `Operation Entity required`
    }),
    divisionIDs: Joi.array().optional().label("Division"),
    noOfCodes: Joi.number().required().invalid(0).min(1).max(100).label("QR Count").messages({
        "any.invalid": `QR Count required`,
        "any.required": `QR Count required`,
        "number.min": `QR Count must be at least {#limit}`,
        "number.max": `QR Count cannot be more than {#limit}`
    })
}
